angular.module("Main").controller("TestController", ["$translate", "BookingService", function ($translate, BookingService) {
    var vm = this;

    let cycleUnits = BookingService.getCycleUnits();
    BookingService.getMembershipCycleList(1).then(function (membershipList) {
        vm.membershipList = membershipList;
    });

    vm.selectMembershipCycle = function (membershipId, termId, cycleId) {
        vm.selected = true;
        loadSelectedMembership(membershipId, termId, cycleId);
    };

    vm.parseCycles = function(value, unit) {
        if (value === 0)
            return $translate.instant("T_einmalig");

        return ((value > 1) ? value + "-" : "") + $translate.instant(cycleUnits[unit][2]);
    };

    function loadSelectedMembership(membershipId, termId, cycleId) {
        BookingService.getMembership(membershipId).then(function (membership) {
            vm.membership = membership;
        });
        BookingService.getMembershipPrices(membershipId, termId, cycleId).then(function (prices) {
            vm.prices = prices;
        });
    }
}]);